import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { requestAccess } from '../../services/marketingChatService';
import logo from '../../assets/images/M_Multicolor.svg';
import '../../styles/RequestEarlyAccess.css';
const RequestEarlyAccessPage: React.FC = () => {
    const { state } = useLocation();
    const [form, setForm] = useState({
        fullName: state?.fullName ?? '',
        email: state?.email ?? '',
        agencyName: state?.agencyName ?? '',
        agencyId: state?.agencyId ?? '',
        agentId: state?.agentId ?? '',
        isCustomer: '',
    });
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!form.fullName.trim() || !form.email.trim())
            return;
        setSubmitting(true);
        setError('');
        try {
            await requestAccess({
                AgencyName: form.agencyName.trim(),
                AgencyId: form.agencyId,
                RequestedAgentId: form.agentId,
            });
            setSubmitted(true);
        }
        catch {
            setError('Something went wrong. Please try again.');
        }
        finally {
            setSubmitting(false);
        }
    };
    return (<div className="rea-page">
      <header className="mkt-topbar">
        <div className="mkt-topbar__left">
          <div className="mkt-topbar__brand">
            <img src={logo} alt="InsuranceAgency.AI" width="28" height="28" className="mkt-topbar__logo"/>
            <div className="mkt-topbar__text">
              <div className="mkt-topbar__title">InsuranceAgency.AI</div>
              <div className="mkt-topbar__subtitle">Your agency's AI operating system</div>
            </div>
          </div>
        </div>
        <div className="mkt-topbar__right">
          <a className="mkt-topbar__signin" href="/login">Sign In</a>
        </div>
      </header>

      <div className="rea-page__body">
      <div className="rea-card">
        <h2 className="rea-card__title">Request Early Access</h2>
        <p className="rea-card__desc">
          Join a select group of agencies getting first access to the future of insurance operations.
        </p>

        {submitted ? (<div className="rea-card__success">
            {"You're on the waitlist! We'll be in touch with details about beta access."}
          </div>) : (<form onSubmit={handleSubmit}>
            <div className="rea-card__group">
              <label htmlFor="rea-name">Full Name *</label>
              <input id="rea-name" type="text" name="fullName" placeholder="Your name" value={form.fullName} onChange={handleChange} required/>
            </div>

            <div className="rea-card__group">
              <label htmlFor="rea-email">Email Address *</label>
              <input id="rea-email" type="email" name="email" placeholder="you@agency.com" value={form.email} onChange={handleChange} required/>
            </div>

            <div className="rea-card__group">
              <label htmlFor="rea-agency">Agency Name</label>
              <input id="rea-agency" type="text" name="agencyName" placeholder="Your agency" value={form.agencyName} onChange={handleChange}/>
            </div>

            <fieldset className="rea-card__fieldset">
              <legend className="rea-card__legend">
                Are you a current Momentum AMP customer?
              </legend>
              <div className="rea-card__radios">
                <label className="rea-card__radio">
                  <input type="radio" name="isCustomer" value="yes" checked={form.isCustomer === 'yes'} onChange={handleChange}/> Yes
                </label>
                <label className="rea-card__radio">
                  <input type="radio" name="isCustomer" value="no" checked={form.isCustomer === 'no'} onChange={handleChange}/> No
                </label>
              </div>
            </fieldset>

            {error && <div className="rea-card__error">{error}</div>}

            <button className="rea-card__cta" type="submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'GET ON THE LIST'}
            </button>
          </form>)}
      </div>
      </div>
    </div>);
};
export default RequestEarlyAccessPage;
